import '../../core/components/app-root/AppRoot.css';
import '../../styles/container.css';
import './Container.css';
export var containerCSS = '_f32lcd0-3-12-1';